function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { encode as base64url } from '../../runtime/base64url.js';
import { unprotected } from '../../lib/private_symbols.js';
import _encrypt from '../../runtime/encrypt.js';
import encryptKeyManagement from '../../lib/encrypt_key_management.js';
import { JOSENotSupported, JWEInvalid } from '../../util/errors.js';
import isDisjoint from '../../lib/is_disjoint.js';
import { encoder, decoder, concat } from '../../lib/buffer_utils.js';
import validateCrit from '../../lib/validate_crit.js';
export var FlattenedEncrypt = /*#__PURE__*/function () {
  function FlattenedEncrypt(plaintext) {
    _classCallCheck(this, FlattenedEncrypt);
    if (!(plaintext instanceof Uint8Array)) {
      throw new TypeError('plaintext must be an instance of Uint8Array');
    }
    this._plaintext = plaintext;
  }
  return _createClass(FlattenedEncrypt, [{
    key: "setKeyManagementParameters",
    value: function setKeyManagementParameters(parameters) {
      if (this._keyManagementParameters) {
        throw new TypeError('setKeyManagementParameters can only be called once');
      }
      this._keyManagementParameters = parameters;
      return this;
    }
  }, {
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      if (this._protectedHeader) {
        throw new TypeError('setProtectedHeader can only be called once');
      }
      this._protectedHeader = protectedHeader;
      return this;
    }
  }, {
    key: "setSharedUnprotectedHeader",
    value: function setSharedUnprotectedHeader(sharedUnprotectedHeader) {
      if (this._sharedUnprotectedHeader) {
        throw new TypeError('setSharedUnprotectedHeader can only be called once');
      }
      this._sharedUnprotectedHeader = sharedUnprotectedHeader;
      return this;
    }
  }, {
    key: "setUnprotectedHeader",
    value: function setUnprotectedHeader(unprotectedHeader) {
      if (this._unprotectedHeader) {
        throw new TypeError('setUnprotectedHeader can only be called once');
      }
      this._unprotectedHeader = unprotectedHeader;
      return this;
    }
  }, {
    key: "setAdditionalAuthenticatedData",
    value: function setAdditionalAuthenticatedData(aad) {
      this._aad = aad;
      return this;
    }
  }, {
    key: "setContentEncryptionKey",
    value: function setContentEncryptionKey(cek) {
      if (this._cek) {
        throw new TypeError('setContentEncryptionKey can only be called once');
      }
      this._cek = cek;
      return this;
    }
  }, {
    key: "setInitializationVector",
    value: function setInitializationVector(iv) {
      if (this._iv) {
        throw new TypeError('setInitializationVector can only be called once');
      }
      this._iv = iv;
      return this;
    }
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(key, options) {
        var joseHeader, alg, enc, encryptedKey, cek, parameters, _yield$encryptKeyMana, additionalData, protectedHeader, aadMember, _yield$_encrypt, ciphertext, tag, iv, jwe;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader)) {
                _context.n = 1;
                break;
              }
              throw new JWEInvalid('either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()');
            case 1:
              if (isDisjoint(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) {
                _context.n = 2;
                break;
              }
              throw new JWEInvalid('JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint');
            case 2:
              joseHeader = _objectSpread(_objectSpread(_objectSpread({}, this._protectedHeader), this._unprotectedHeader), this._sharedUnprotectedHeader);
              validateCrit(JWEInvalid, new Map(), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
              if (!(joseHeader.zip !== undefined)) {
                _context.n = 3;
                break;
              }
              throw new JOSENotSupported('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
            case 3:
              alg = joseHeader.alg, enc = joseHeader.enc;
              if (!(typeof alg !== 'string' || !alg)) {
                _context.n = 4;
                break;
              }
              throw new JWEInvalid('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            case 4:
              if (!(typeof enc !== 'string' || !enc)) {
                _context.n = 5;
                break;
              }
              throw new JWEInvalid('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            case 5:
              if (!(this._cek && (alg === 'dir' || alg === 'ECDH-ES'))) {
                _context.n = 6;
                break;
              }
              throw new TypeError("setContentEncryptionKey cannot be called with JWE \"alg\" (Algorithm) Header ".concat(alg));
            case 6:
              _context.n = 7;
              return encryptKeyManagement(alg, enc, key, this._cek, this._keyManagementParameters);
            case 7:
              _yield$encryptKeyMana = _context.v;
              cek = _yield$encryptKeyMana.cek;
              encryptedKey = _yield$encryptKeyMana.encryptedKey;
              parameters = _yield$encryptKeyMana.parameters;
              if (parameters) {
                if (options && unprotected in options) {
                  if (!this._unprotectedHeader) {
                    this.setUnprotectedHeader(parameters);
                  } else {
                    this._unprotectedHeader = _objectSpread(_objectSpread({}, this._unprotectedHeader), parameters);
                  }
                } else if (!this._protectedHeader) {
                  this.setProtectedHeader(parameters);
                } else {
                  this._protectedHeader = _objectSpread(_objectSpread({}, this._protectedHeader), parameters);
                }
              }
              if (this._protectedHeader) {
                protectedHeader = encoder.encode(base64url(JSON.stringify(this._protectedHeader)));
              } else {
                protectedHeader = encoder.encode('');
              }
              if (this._aad) {
                aadMember = base64url(this._aad);
                additionalData = concat(protectedHeader, encoder.encode('.'), encoder.encode(aadMember));
              } else {
                additionalData = protectedHeader;
              }
              _context.n = 8;
              return _encrypt(enc, this._plaintext, cek, this._iv, additionalData);
            case 8:
              _yield$_encrypt = _context.v;
              ciphertext = _yield$_encrypt.ciphertext;
              tag = _yield$_encrypt.tag;
              iv = _yield$_encrypt.iv;
              jwe = {
                ciphertext: base64url(ciphertext)
              };
              if (iv) {
                jwe.iv = base64url(iv);
              }
              if (tag) {
                jwe.tag = base64url(tag);
              }
              if (encryptedKey) {
                jwe.encrypted_key = base64url(encryptedKey);
              }
              if (aadMember) {
                jwe.aad = aadMember;
              }
              if (this._protectedHeader) {
                jwe.protected = decoder.decode(protectedHeader);
              }
              if (this._sharedUnprotectedHeader) {
                jwe.unprotected = this._sharedUnprotectedHeader;
              }
              if (this._unprotectedHeader) {
                jwe.header = this._unprotectedHeader;
              }
              return _context.a(2, jwe);
          }
        }, _callee, this);
      }));
      function encrypt(_x, _x2) {
        return _encrypt2.apply(this, arguments);
      }
      return encrypt;
    }()
  }]);
}();